import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';
import type { FilterOptions, GetOptions, PaginationOptions, RequestConfig } from 'api/types';
import type { ReviewQuestionnaireFilters } from 'constants/reviewQuestionnaireFilters';

export type ClientReviewQuestionnairesGetOptions = GetOptions &
  PaginationOptions &
  FilterOptions<ReviewQuestionnaireFilters>;

export function clientReviewQuestionnairesApi(path: string) {
  return {
    path,
    GET: (params: ClientReviewQuestionnairesGetOptions = {}, config?: RequestConfig) => {
      const { pageSize, pageNumber, ...rest } = params;

      return api.get<JsonApiResponse>(path, {
        params: {
          per_page: pageSize,
          page: pageNumber,
          ...rest,
        },
        ...config,
      });
    },
  };
}
